import { useT } from '@kmgestao/i18n';
import { Badge, PageContainer, PageIntroCard, PageSectionCard } from '@kmgestao/ui';

import { useCurrentClinicId } from '../../../../features/auth/index.js';
import { ClinicShell } from '../../ClinicShell.js';

import { ByokCard } from './ByokCard.js';
import { ModulesCard } from './ModulesCard.js';

/**
 * Página da clínica em `/settings/ai`. Segue o padrão canônico das páginas
 * internas (`PageContainer` + `PageIntroCard` + `PageSectionCard`) — ver
 * `docs/design-system.md` §"Padrão para páginas internas".
 *
 * Acesso: `clinic_admin`, `clinic_owner` e Superadmin (via
 * `<RequireClinicAdmin>`). O `clinicId` vem da claim `current_clinic_id`
 * do JWT (migration 0027).
 */
export function ClinicAiSettingsPage() {
  const { t } = useT('ai-clinic');
  const clinicId = useCurrentClinicId();

  return (
    <ClinicShell>
      <PageContainer>
        <PageIntroCard
          eyebrow={t('page.breadcrumb')}
          title={t('page.title')}
          description={t('page.subtitle')}
          meta={
            <>
              <Badge>{t('modules.title')}</Badge>
              <Badge variant="outline">{t('byok.title')}</Badge>
            </>
          }
        />

        {clinicId ? (
          <>
            <ModulesCard clinicId={clinicId} />
            <ByokCard clinicId={clinicId} />
          </>
        ) : (
          <PageSectionCard title={t('noClinic.title')} description={t('noClinic.description')}>
            <div />
          </PageSectionCard>
        )}
      </PageContainer>
    </ClinicShell>
  );
}
